module.exports = __webpack_public_path__ + "media/public/images/slider/banner_desktop-38474e7a6c74ec2f2f45a49b294cff0c.png";